<template>
  <section class="featured-products">
    <!-- Main Featured Product -->
    <div class="featured-product">
      <img src="@/assets/featured-product.jpg" alt="Featured Product" class="featured-image" />
      <div class="product-info">
        <h2 class="product-title">Banana Model X</h2>
        <p class="product-description">Ultra-lightweight, Tactical Precision, Enhanced Durability</p>
        <span class="product-price">$299.99</span>
        <button class="add-to-cart-btn">Add to Cart</button>
      </div>
    </div>

    <!-- Other Products -->
    <div class="other-products">
      <h3 class="other-products-title">Explore More Products</h3>
      <div class="product-grid">
        <div class="product-item" v-for="(product, index) in otherProducts" :key="index">
          <img :src="product.image" :alt="product.name" class="product-thumbnail" />
          <p class="product-name">{{ product.name }}</p>
          <p class="product-short-description">{{ product.description }}</p>
          <button class="view-more-btn">View More</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FeaturedProducts",
  data() {
    return {
      otherProducts: [
        {
          name: "Tactical Banana Gear",
          description: "Durable and lightweight tactical gear.",
          image: "@/assets/other-product1.jpg",
        },
        {
          name: "Advanced Banana Sights",
          description: "Enhanced precision and clarity.",
          image: "@/assets/other-product2.jpg",
        },
        {
          name: "Banana Protective Case",
          description: "Protect your investment with style.",
          image: "@/assets/other-product3.jpg",
        },
      ],
    };
  },
};
</script>

<style scoped>
.featured-products {
  padding: 40px 20px;
  text-align: center;
}

.featured-product {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}

.featured-image {
  width: 300px;
  margin-right: 20px;
}

.product-info {
  max-width: 400px;
}

.product-title {
  font-size: 2em;
  font-weight: bold;
  margin: 0;
}

.product-description {
  font-size: 1.2em;
  margin: 10px 0;
}

.product-price {
  font-size: 1.5em;
  color: crimson;
  font-weight: bold;
  display: block;
  margin-top: 10px;
}

.add-to-cart-btn {
  padding: 10px 20px;
  font-size: 1em;
  background-color: crimson;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
}

.other-products {
  margin-top: 40px;
}

.other-products-title {
  font-size: 1.8em;
  margin-bottom: 20px;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
}

.product-item {
  text-align: center;
  background-color: #f7f7f7;
  padding: 20px;
  border-radius: 8px;
}

.product-thumbnail {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-bottom: 10px;
}

.product-name {
  font-size: 1.1em;
  font-weight: bold;
}

.product-short-description {
  font-size: 0.9em;
  color: #666;
}

.view-more-btn {
  padding: 5px 15px;
  font-size: 0.9em;
  background-color: gray;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}
</style>
